export default __webpack_public_path__ + "static/media/2003.0bc85498.png";